// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__Dhk+d","info":"Panel_info__6Q6E7","note":"Panel_note__kRNuF","close":"Panel_close__ujEZj","btns":"Panel_btns__5jMTn","button":"Panel_button__1a4A7"};